<template>
  <div class="video-container" :class="{ 'ready': this.isReady }">
    <video class="video" :loop="isReady" :autoplay="isReady" playsinline :muted="muted" ref="video">
        <source :src="src" :type="getMediaType()">
    </video>
  </div>
</template>

<script>
export default {
  props: {
    canPlay: {
      type: Boolean,
      default: false
    },
    muted: {
      type: Boolean,
      default: true
    },
    isReady: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      src: 'src/assets/video/buzzer_mobile_video_min.mp4'
    }
  },
  mounted () {
    this.setVideoSize()
  },
  watch: {
    canPlay (value) {
      if (value) {
        this.$refs.video.play()
      }
    },
    isReady (value) {
      if (value) {
        this.src = 'src/assets/video/buzzer_order_ready_min.mp4'
      }
    }
  },
  methods: {
    setVideoSize () {
      this.$refs.video.style.width = this.isReady
        ? screen.width + 'px'
        : screen.width * 1.2 + 'px'
    },
    getMediaType () {
      return 'video/' + this.src.split('.').pop()
    },
    videoCanPlay () {
      return this.canPlay
    }
  }
}
</script>

<style lang="scss" scoped>
  .video-container {
    position: relative;
    width: 100%;
    height: calc(100% / 2.2);
    min-height: 200px;
    max-height: 350px;
    overflow: hidden;
  }

  .video {
    position: absolute;
    z-index: 10;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-size: cover;
    background-position: center;
    overflow: hidden;
    /* height: 120%; */
  }
  
  // .ready {
  //   height: calc(100% / 1.7);

  //   .video {
  //     top: 70%;
  //   }
  // }

  @media screen and (max-width: 320px) {
    .VideoBg {
      margin-top: -15px;
      margin-bottom: -15px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/shared/Video.vue